/**
 * Returns the internet discount percentage for a trip
 * @param {boolean} isNewUser - Whether the user is new
 * @param {string} way - The way of the trip (return or departure)
 * @returns {string|null} The discount percentage as a string or null if not applicable
 */
const getInternetDiscountPercent = (isNewUser, way) => {
  if (!isNewUser) return null;
  if (way === 'departure') return '5%';
  if (way === 'return') return '10%';
  return null;
};

export default getInternetDiscountPercent;
